function LatestArticleCpn({data}){

    const {title="",image="",desc="",category="",date=""} = data || {};

    return (
        <>
                <a href="/review/analog-crypto-review/">
                        <div className="LatestArticles_articleCard__G8_9c">
                                        <div className="LatestArticles_articleThumbnail__wEspR">
                                        <span
                                            style={{
                                            boxSizing: "border-box",
                                            display: "inline-block",
                                            overflow: "hidden",
                                            width: "initial",
                                            height: "initial",
                                            background: "none",
                                            opacity: 1,
                                            border: 0,
                                            margin: 0,
                                            padding: 0,
                                            position: "relative",
                                            maxWidth: "100%"
                                            }}
                                        >
                                            <span
                                            style={{
                                                boxSizing: "border-box",
                                                display: "block",
                                                width: "initial",
                                                height: "initial",
                                                background: "none",
                                                opacity: 1,
                                                border: 0,
                                                margin: 0,
                                                padding: 0,
                                                maxWidth: "100%"
                                            }}
                                            >
                                            <img
                                                alt=""
                                                aria-hidden="true"
                                                src="data:image/svg+xml,%3csvg%20xmlns=%27http://www.w3.org/2000/svg%27%20version=%271.1%27%20width=%27160%27%20height=%2790%27/%3e"
                                                style={{
                                                display: "block",
                                                maxWidth: "100%",
                                                width: "initial",
                                                height: "initial",
                                                background: "none",
                                                opacity: 1,
                                                border: 0,
                                                margin: 0,
                                                padding: 0
                                                }}
                                            />
                                            </span>
                                            <img
                                            alt="Analog Review 2025: The Future of Blockchain Interoperability?"
                                            src={image}
                                            decoding="async"
                                            data-nimg="intrinsic"
                                            className="LatestArticles_articleThumbnailImage__Mumvk"
                                            style={{
                                                position: "absolute",
                                                inset: 0,
                                                boxSizing: "border-box",
                                                padding: 0,
                                                border: "none",
                                                margin: "auto",
                                                display: "block",
                                                width: 0,
                                                height: 0,
                                                minWidth: "100%",
                                                maxWidth: "100%",
                                                minHeight: "100%",
                                                maxHeight: "100%",
                                                objectFit: "cover"
                                            }}
                                            />
                                            <noscript />
                                        </span>
                                        </div>
                                        <div className="LatestArticles_detailsDiv__BTKf4">
                                        <div className="LatestArticles_articleCategory___ohLh">
                                            {category}
                                        </div>
                                        <div className="LatestArticles_articleTitle__23HOj">
                                           {title}
                                        </div>
                                        </div>
                        </div>
                </a>
        </>
    )
}

export default LatestArticleCpn;